import React, { Component } from 'react'

class EstimationEditTab extends Component {
  constructor (props) {
    super(props)
    this.state = {currentTabId: this.props.currentTabId}
  }
  render () {
    const tabList = [
      {id: 'LaborUnitPriceTab', name: '労務単価'},
      {id: 'EstimationConditionsTab', name: '見積条件'},
      {id: 'LaborCostTab', name: '工事費内訳（労務費）'},
      {id: 'MaterialCostTab', name: '工事費内訳（材料費）'},
      {id: 'EstimationSheetTab', name: '見積書'}
    ].map((tab, index) => {
      return (
        <li key={'tab' + index} className={this.state.currentTabId === tab.id ? 'active' : ''} >
          <a onClick={(e) => this.onTabClicked(tab.id, e)}>{tab.name}</a>
        </li>
      )
    })
    return (
      <ul className='nav nav-tabs'>
        {tabList}
      </ul>
    )
  }
  onTabClicked (tabId, e) {
    if (this.props.onTabClick) {
      this.props.onTabClick(tabId)
    }
    this.setState({currentTabId: tabId})
  }
}
EstimationEditTab.defaultProps = {currentTabId: 'EstimationSheetTab', onTabClick: false}
export default EstimationEditTab



// WEBPACK FOOTER //
// ./src/company_user/pages/secure/EstimationEditTab.js